export enum PageOrientation {
    Portrait,
    Landscape
}